function openNav() {
    document.getElementById("mySidebar").style.width = "100%";
    document.getElementById("mySidebar").style.transition = "0.1s";
    document.getElementById("mySidebar").style.boxShadow = "0 0 0 10000px rgba(0,0,0,.75) ";
    document.getElementById("SidebarUl").style.opacity = "1";
    document.getElementById("SidebarUl").style.transition = "0.2s"
}

function closeNav() {
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("mySidebar").style.boxShadow = "none ";
    document.getElementById("SidebarUl").style.opacity = "0 ";
    document.getElementById("SidebarUl").style.transition = "0.1s"

}



$(document).ready(function () {
    $(window).scroll(function () {
        var scrolltop4 = $(document).scrollTop();
        console.log(scrolltop4);

        if (scrolltop4 > 10) {

            $('.header-wrapper').addClass("scoll-header-bg");
        } else {
            $(".header-wrapper").removeClass("scoll-header-bg");
        };



//    footer mobile
        if (scrolltop4 > 10) {

            $('.mobile_header').addClass("scoll-header-bg");
        } else {
            $(".mobile_header").removeClass("scoll-header-bg");
        };

    });


});

$('.announceSl').slick({
    slidesToShow: 1,
    dots: false,
    prevArrow: '<button class="AnnouncementLeft AnnouncementArrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/> </svg></button>',
    nextArrow: '<button class="AnnouncementRight AnnouncementArrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/> </svg></button>',
    infinite: true,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 4000,
});
